import Vue from 'vue'
import Vuex from 'vuex'

import HScene from '@/core/HScene.js'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    hScene: null
  },

  mutations: {
    newHScene (state) {
      state.hScene = new HScene()
      window.hScene = state.hScene
    },
    setHScene (state, hScene) {
      state.hScene = hScene
    }
  },

  actions: {

  }
})

export default store



// WEBPACK FOOTER //
// ./src/store.js